function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useRef, useState, useEffect, useCallback } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { T, useTranslate } from 'shared/helper/translate';
import { convertFormDataToRubriqTestimonialCreationRequest } from 'shared/view/testimonial-conversion-service';
import './submit-rubriq-testimonial-form.scss';
var JOB_TITLE_OPTIONS = [{
  value: "PhD Student Master's",
  key: 'curie.job_title.option.phd_student'
}, {
  value: 'Graduate Student',
  key: 'curie.job_title.option.graduate_student'
}, {
  value: 'Postdoctoral Researcher',
  key: 'curie.job_title.option.postdoc'
}, {
  value: 'Assistant Professor',
  key: 'curie.job_title.option.assistant_professor'
}, {
  value: 'Associate Professor',
  key: 'curie.job_title.option.associate_professor'
}, {
  value: 'Professor',
  key: 'curie.job_title.option.professor'
}, {
  value: 'Research Assistant',
  key: 'curie.job_title.option.research_scientist'
}, {
  value: 'Faculty Principal Investigator',
  key: 'curie.job_title.option.faculty'
}, {
  value: 'Lab Head',
  key: 'curie.job_title.option.labhead'
}, {
  value: 'Independent Researcher',
  key: 'curie.job_title.option.independent_researcher'
}, {
  value: 'Clinician Industry Researcher',
  key: 'curie.job_title.option.clinical_researcher'
}, {
  value: 'Undergraduate Student',
  key: 'curie.job_title.option.undergrauate_researcher'
}, {
  value: 'Other',
  key: 'curie.job_title.option.other'
}];
var FIELD_OPTIONS = [{
  value: 'Biology / Life Sciences',
  key: 'curie.field.option.biology'
}, {
  value: 'Chemistry',
  key: 'curie.field.option.chemistry'
}, {
  value: 'Computer Science / AI',
  key: 'curie.field.option.cs_ai'
}, {
  value: 'Earth & Environmental Sciences',
  key: 'curie.field.option.earth_env'
}, {
  value: 'Engineering',
  key: 'curie.field.option.engineering'
}, {
  value: 'Mathematics / Statistics',
  key: 'curie.field.option.math_stats'
}, {
  value: 'Medicine / Clinical Research',
  key: 'curie.field.option.medicine'
}, {
  value: 'Physics',
  key: 'curie.field.option.physics'
}, {
  value: 'Psychology / Neuroscience',
  key: 'curie.field.option.psych_neuro'
}, {
  value: 'Social Sciences',
  key: 'curie.field.option.social_sciences'
}, {
  value: 'Other',
  key: 'curie.job_title.option.other'
}];
var OUTCOME_OPTIONS = [{
  value: 'Published',
  key: 'curie.outcome.option.published'
}, {
  value: 'Accepted',
  key: 'curie.outcome.option.accepted'
}, {
  value: 'Awaiting Publication',
  key: 'curie.outcome.option.awaitingpublication'
}, {
  value: 'Under review',
  key: 'curie.outcome.option.under_review'
}, {
  value: 'Revising based on feedback',
  key: 'curie.outcome.option.revision_requested'
}, {
  value: 'Not yet submitted',
  key: 'curie.outcome.option.notyetsubmitted'
}, {
  value: 'Preparing to submit',
  key: 'curie.outcome.option.preparing'
}, {
  value: 'Other',
  key: 'curie.job_title.option.other'
}];
var MANUSCRIPT_OPTIONS = [{
  value: 'Research Article',
  key: 'curie.manuscript_type.option.original_research'
}, {
  value: 'Review Paper',
  key: 'curie.manuscript_type.option.review_article'
}, {
  value: 'Thesis/Dissertation',
  key: 'curie.manuscript_type.option.case_report'
}, {
  value: 'Grant Proposal',
  key: 'curie.manuscript_type.option.short_communication'
}, {
  value: 'Conference Paper',
  key: 'curie.manuscript_type.option.conference_paper'
}, {
  value: 'Book Chapter',
  key: 'curie.manuscript_type.option.book_chapter'
}, {
  value: 'Other',
  key: 'curie.job_title.option.other'
}];
var defaultValues = {
  testimonial: '',
  displayName: '',
  photoFiles: [],
  jobTitle: '',
  fieldDiscipline: '',
  institution: '',
  outcome: '',
  manuscriptType: '',
  linkedinOrcid: '',
  consent: false
};

// ── Chevron icon ─────────────────────────────────────────────────────────────
var ChevronIcon = function ChevronIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 12 8",
    "aria-hidden": "true",
    className: "chevron-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1l5 5 5-5",
    stroke: "currentColor",
    strokeWidth: "1.8",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

// ── Custom dropdown ───────────────────────────────────────────────────────────
// FIX: accept `t` as a prop so option labels can be translated instead of
// always rendering the raw English `value`.
var CustomSelect = function CustomSelect(_ref) {
  var id = _ref.id,
    placeholder = _ref.placeholder,
    options = _ref.options,
    value = _ref.value,
    onChange = _ref.onChange,
    t = _ref.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var ref = useRef(null);
  var selected = options.find(function (o) {
    return o.value === value;
  });

  // FIX: helper that resolves the display label for an option — translates
  // via its `key` when available, falling back to the raw `value` (e.g. for
  // any option that doesn't carry a translation key).
  var label = function label(option) {
    return option.key ? t(option.key) : option.value;
  };
  var close = useCallback(function () {
    return setOpen(false);
  }, []);
  useEffect(function () {
    if (!open) return;
    var handleClick = function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) close();
    };
    var handleKey = function handleKey(e) {
      if (e.key === 'Escape') close();
    };
    document.addEventListener('mousedown', handleClick);
    document.addEventListener('keydown', handleKey);
    return function () {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('keydown', handleKey);
    };
  }, [open, close]);
  var select = function select(val) {
    onChange(val);
    setOpen(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    id: id,
    className: "rubriq-custom-select".concat(open ? ' is-open' : ''),
    role: "combobox",
    "aria-expanded": open,
    "aria-haspopup": "listbox",
    tabIndex: 0,
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setOpen(function (o) {
          return !o;
        });
      }
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "rcs-trigger".concat(!value ? ' is-placeholder' : ''),
    onClick: function onClick() {
      return setOpen(function (o) {
        return !o;
      });
    }
    // FIX: use translated label for the accessible name too
    ,
    "aria-label": selected ? label(selected) : placeholder
  }, /*#__PURE__*/React.createElement("span", null, selected ? label(selected) : placeholder), /*#__PURE__*/React.createElement(ChevronIcon, null)), open && /*#__PURE__*/React.createElement("ul", {
    className: "rcs-dropdown",
    role: "listbox"
  }, options.map(function (o) {
    return /*#__PURE__*/React.createElement("li", {
      key: o.value,
      role: "option",
      "aria-selected": o.value === value,
      className: "rcs-option".concat(o.value === value ? ' is-selected' : ''),
      onMouseDown: function onMouseDown(e) {
        e.preventDefault();
        select(o.value);
      }
    }, label(o));
  })));
};

// ── Upload icon SVG ──────────────────────────────────────────────────────────
var UploadIcon = function UploadIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "16 16 12 12 8 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "12",
    y1: "12",
    x2: "12",
    y2: "21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"
  }));
};

// ── File icon SVG ────────────────────────────────────────────────────────────
var FileIcon = function FileIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "13 2 13 9 20 9"
  }));
};
var formatFileSize = function formatFileSize(bytes) {
  if (bytes < 1024) return "".concat(bytes, " B");
  if (bytes < 1024 * 1024) return "".concat(Math.round(bytes / 1024), " KB");
  return "".concat((bytes / (1024 * 1024)).toFixed(1), " MB");
};
var ThankYou = function ThankYou(_ref2) {
  var displayName = _ref2.displayName;
  var firstName = displayName ? displayName.split(' ')[0] : '';

  // FIX: reset scroll position when this screen mounts, since the user
  // was scrolled near the bottom of the form when they submitted.
  useEffect(function () {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "rubriq-thankyou"
  }, /*#__PURE__*/React.createElement("div", {
    className: "check-circle"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "20 6 9 17 4 12"
  }))), /*#__PURE__*/React.createElement("h2", null, firstName ? "Thank you, ".concat(firstName, "!") : 'Thank you!'), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, {
    source: "curie.thankyou.body"
  })));
};
var SubmitRubriqTestimonialForm = function SubmitRubriqTestimonialForm(_ref3) {
  var persistTestimonial = _ref3.persistTestimonial;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var user = useSelector(function (_ref4) {
    var user = _ref4.user;
    return user;
  });

  // FIX: derive China from the URL path segment (e.g. /cn/testimonials/...)
  // instead of relying on useTranslate()'s return shape, which didn't
  // reflect the locale.
  var isChina = typeof window !== 'undefined' && /^\/cn(\/|$)/.test(window.location.pathname);
  var privacyPolicyUrl = isChina ? 'https://rubriq.cn/security-and-privacy/' : 'https://www.rubriq.com/security-and-privacy/';
  var prefillName = user !== null && user !== void 0 && user.firstName ? "".concat(user.firstName).concat(user.lastName ? " ".concat(user.lastName.charAt(0), ".") : '') : '';
  var methods = useForm({
    defaultValues: _objectSpread(_objectSpread({}, defaultValues), {}, {
      displayName: prefillName
    }),
    shouldFocusError: false
  });
  var register = methods.register,
    handleSubmit = methods.handleSubmit,
    errors = methods.formState.errors,
    watch = methods.watch,
    setValue = methods.setValue;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    submitting = _useState4[0],
    setSubmitting = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    submitted = _useState6[0],
    setSubmitted = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    submitError = _useState8[0],
    setSubmitError = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    submittedDisplayName = _useState10[0],
    setSubmittedDisplayName = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    photoFiles = _useState12[0],
    setPhotoFiles = _useState12[1];
  var fileInputRef = useRef(null);
  var consent = watch('consent');
  var jobTitle = watch('jobTitle');
  var fieldDiscipline = watch('fieldDiscipline');
  var outcome = watch('outcome');
  var manuscriptType = watch('manuscriptType');
  var handleFileChange = function handleFileChange(e) {
    var selected = Array.from(e.target.files || []);
    if (selected.length === 0) return;
    var file = selected[0];
    setPhotoFiles([file]);
    setValue('photoFiles', [file]);
    e.target.value = '';
  };
  var removeFile = function removeFile() {
    setPhotoFiles([]);
    setValue('photoFiles', []);
  };
  var onSubmit = function onSubmit(formData) {
    setSubmitting(true);
    setSubmitError('');
    var payload = convertFormDataToRubriqTestimonialCreationRequest(_objectSpread(_objectSpread({}, formData), {}, {
      photoFiles: photoFiles
    }));
    persistTestimonial(payload).then(function (json) {
      setSubmitting(false);
      if (json.error) {
        setSubmitError(json.error.error || t('curie.submit.error_generic'));
      } else {
        setSubmittedDisplayName(formData.displayName || '');
        setSubmitted(true);
      }
    });
  };
  if (submitted) {
    return /*#__PURE__*/React.createElement(ThankYou, {
      displayName: submittedDisplayName
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "rubriq-testimonial-page"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "rubriq-heading"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.heading"
  })), /*#__PURE__*/React.createElement("p", {
    className: "rubriq-subtitle"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.small_words"
  })), /*#__PURE__*/React.createElement("div", {
    className: "reward-line"
  }, /*#__PURE__*/React.createElement("span", {
    className: "reward-tag"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.reward_tag"
  })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(T, {
    source: "curie.reward_text.pre"
  }), ' ', /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(T, {
    source: "curie.reward_text.month_1"
  })), ' ', /*#__PURE__*/React.createElement(T, {
    source: "curie.reward_text.mid"
  }), ' ', /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(T, {
    source: "curie.reward_text.months_2"
  })), ' ', /*#__PURE__*/React.createElement(T, {
    source: "curie.reward_text.post"
  }))), /*#__PURE__*/React.createElement(FormProvider, methods, /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit(onSubmit),
    noValidate: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "rubriq-field"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "testimonial"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.testimonial.label"
  }), /*#__PURE__*/React.createElement("span", {
    className: "required"
  }, " *")), /*#__PURE__*/React.createElement("textarea", _extends({
    id: "testimonial",
    className: "rubriq-input",
    placeholder: t('curie.testimonial.placeholder')
  }, register('testimonial', {
    required: t('curie.testimonial.error_required')
  }))), errors.testimonial && /*#__PURE__*/React.createElement("div", {
    className: "error-msg"
  }, errors.testimonial.message)), /*#__PURE__*/React.createElement("div", {
    className: "rubriq-field"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "displayName"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.display_name.label"
  }), /*#__PURE__*/React.createElement("span", {
    className: "required"
  }, " *")), /*#__PURE__*/React.createElement("input", _extends({
    id: "displayName",
    type: "text",
    className: "rubriq-input",
    placeholder: prefillName ? "e.g., ".concat(prefillName) : t('curie.display_name.label')
  }, register('displayName', {
    required: t('curie.display_name.error_required')
  }))), errors.displayName ? /*#__PURE__*/React.createElement("div", {
    className: "error-msg"
  }, errors.displayName.message) : /*#__PURE__*/React.createElement("div", {
    className: "field-hint"
  }, "First name + last initial is fine \u2014 displayed exactly as entered.")), /*#__PURE__*/React.createElement("div", {
    className: "photo-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "photo-label"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.photo.label"
  })), /*#__PURE__*/React.createElement("div", {
    className: "photo-incentive"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.photo.incentive"
  })), /*#__PURE__*/React.createElement("div", {
    className: "photo-upload-row"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "upload-btn",
    onClick: function onClick() {
      var _fileInputRef$current;
      return (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 ? void 0 : _fileInputRef$current.click();
    }
  }, /*#__PURE__*/React.createElement(UploadIcon, null), "Upload photo"), /*#__PURE__*/React.createElement("span", {
    className: "upload-hint"
  }, photoFiles.length > 0 ? '1 file selected' : 'JPG or PNG, up to 10 MB')), /*#__PURE__*/React.createElement("input", {
    ref: fileInputRef,
    type: "file",
    accept: "image/jpeg,image/png",
    style: {
      display: 'none'
    },
    onChange: handleFileChange
  }), photoFiles.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "file-list"
  }, photoFiles.map(function (file) {
    return /*#__PURE__*/React.createElement("div", {
      key: file.name,
      className: "file-item"
    }, /*#__PURE__*/React.createElement("span", {
      className: "file-info"
    }, /*#__PURE__*/React.createElement(FileIcon, null), file.name, "\xA0\xA0", formatFileSize(file.size)), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "file-remove",
      "aria-label": "Remove file",
      onClick: removeFile
    }, "\xD7"));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "optional-divider"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(T, {
    source: "curie.divider.optional_details"
  }))), /*#__PURE__*/React.createElement("p", {
    className: "optional-hint"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.divider.optional_details_hint"
  })), /*#__PURE__*/React.createElement("div", {
    className: "rubriq-field"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "jobTitle"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.job_title.label"
  })), /*#__PURE__*/React.createElement(CustomSelect, {
    id: "jobTitle",
    placeholder: t('curie.job_title.placeholder'),
    options: JOB_TITLE_OPTIONS,
    value: jobTitle,
    onChange: function onChange(val) {
      return setValue('jobTitle', val);
    },
    t: t // FIX: pass translate fn down so options render translated
  })), /*#__PURE__*/React.createElement("div", {
    className: "rubriq-field"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "fieldDiscipline"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.field.label"
  })), /*#__PURE__*/React.createElement(CustomSelect, {
    id: "fieldDiscipline",
    placeholder: t('curie.field.placeholder'),
    options: FIELD_OPTIONS,
    value: fieldDiscipline,
    onChange: function onChange(val) {
      return setValue('fieldDiscipline', val);
    },
    t: t // FIX
  })), /*#__PURE__*/React.createElement("div", {
    className: "rubriq-field"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "institution"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.institution.label"
  })), /*#__PURE__*/React.createElement("input", _extends({
    id: "institution",
    type: "text",
    className: "rubriq-input",
    placeholder: t('curie.institution.placeholder')
  }, register('institution')))), /*#__PURE__*/React.createElement("div", {
    className: "rubriq-field"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "outcome"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.outcome.label"
  })), /*#__PURE__*/React.createElement(CustomSelect, {
    id: "outcome",
    placeholder: t('curie.outcome.placeholder'),
    options: OUTCOME_OPTIONS,
    value: outcome,
    onChange: function onChange(val) {
      return setValue('outcome', val);
    },
    t: t // FIX
  })), /*#__PURE__*/React.createElement("div", {
    className: "rubriq-field"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "manuscriptType"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.manuscript_type.label"
  })), /*#__PURE__*/React.createElement(CustomSelect, {
    id: "manuscriptType",
    placeholder: t('curie.manuscript_type.placeholder'),
    options: MANUSCRIPT_OPTIONS,
    value: manuscriptType,
    onChange: function onChange(val) {
      return setValue('manuscriptType', val);
    },
    t: t // FIX
  })), /*#__PURE__*/React.createElement("div", {
    className: "rubriq-field"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "linkedinOrcid"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.linkedin_orcid.label"
  })), /*#__PURE__*/React.createElement("input", _extends({
    id: "linkedinOrcid",
    type: "text",
    className: "rubriq-input",
    placeholder: t('curie.linkedin_orcid.placeholder')
  }, register('linkedinOrcid'))), /*#__PURE__*/React.createElement("div", {
    className: "field-hint"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.linkedin_orcid.hint"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "consent-block"
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: "consent",
    type: "checkbox"
  }, register('consent', {
    required: t('curie.consent.error_required')
  }))), /*#__PURE__*/React.createElement("label", {
    htmlFor: "consent"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.consent.text_pre"
  }), ' ', /*#__PURE__*/React.createElement("a", {
    href: privacyPolicyUrl,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.consent.privacy_link"
  })), /*#__PURE__*/React.createElement(T, {
    source: "curie.consent.text_post"
  }))), errors.consent && /*#__PURE__*/React.createElement("div", {
    className: "consent-error"
  }, errors.consent.message), submitError && /*#__PURE__*/React.createElement("div", {
    className: "submit-error"
  }, submitError), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "submit-btn",
    disabled: submitting || !consent
  }, submitting ? t('curie.submit.button_loading') : t('curie.submit.button')))));
};
export default SubmitRubriqTestimonialForm;